// src/ProtectFlight.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var ProtectFlight_default = createIcon({
  displayName: "ProtectFlight",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.188 4.2835L11.188 1.1725C11.705 0.9425 12.295 0.9425 12.812 1.1725L19.812 4.2835C20.535 4.6045 21 5.3215 21 6.1115V10.8115C21 18.6415 14.561 22.2975 12 22.8115C9.439 22.2975 3 18.6415 3 10.8115V6.1115C3 5.3205 3.465 4.6045 4.188 4.2835ZM14.3198 8.29248C14.661 7.93199 15.2294 7.92207 15.5829 8.27044C15.9364 8.6188 15.9465 9.19877 15.6054 9.55926L14.3067 10.9316L14.4145 15.4118L13.8233 16.0365L12.6397 12.6931L11.3313 14.0756L11.2859 15.4361L10.6657 16.0916L10.0116 14.8138L9.36887 14.1804L8.09457 13.558L8.71485 12.9026L10.0457 12.8089L11.3541 11.4263L8.03833 10.336L8.62953 9.71124L13.0211 9.6648L14.3198 8.29248Z",
        fill: "currentColor"
      })
    ]
  })
});

export {
  ProtectFlight_default
};
